"use client";

// We can't use the ModalContainer and other client components from @decibeltrade/web-core because it's a server component
// and we need to use a client component to render the modal container.
// This is a workaround to allow us to use the ModalContainer in a server component.

import { ModalContainer as DecibelModalContainer } from "@decibeltrade/web-core/modal";

export const ModalContainer = () => {
  return <DecibelModalContainer />;
};
